import { useEffect } from "react";

import { Account } from "~/bff/types/Account";
import { BloomreachPageType } from "~/constants/bloomreach";
import { LOCALES } from "~/constants/i18n";
import { getBloomreachCatalogsAzureKeys } from "~/helpers/get-bloomreach-catalogs-azure-keys";
import { initBloomreachPixel } from "~/helpers/init-bloomreach-pixel";
import { ClientConfig } from "~/services/azure-configurator/types";

interface BloomreachPixelEventParams {
  pageType: BloomreachPageType;
  catalogsAzureKeys: keyof NonNullable<ClientConfig["bloomReachPixel"]>;
  queryParam: string;
  title: string;
  pageLocale: LOCALES;
  currentTab: string;
  account: Account | undefined;
  previousPath: string | undefined;
}

export const useBloomreachPixelEvent = ({
  pageType,
  catalogsAzureKeys,
  queryParam,
  title,
  pageLocale,
  currentTab,
  account,
  previousPath,
}: BloomreachPixelEventParams) => {
  useEffect(() => {
    const bloomreachData = {
      pType: pageType,
      title,
      searchTerm: queryParam,
      catalogs: [
        {
          name: getBloomreachCatalogsAzureKeys(pageLocale, catalogsAzureKeys),
        },
      ],
      user_id: account ? account.uid : "",
    };

    initBloomreachPixel(bloomreachData, pageLocale, previousPath);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    catalogsAzureKeys,
    pageType,
    account,
    pageLocale,
    queryParam,
    title,
    currentTab,
  ]);
};
